export const pointOfSalesQueryKeys = {
  all: ['pointOfSales'] as const,
};
